import React from "react";
import { Input, DateInput } from "../../../common/Input";
import { VesselPickerField } from "../../../common/selectComponents/VesselPicker";

/**
 * Tab 1 — Vessel Details
 *
 * Fields:
 *   - Vessel Code       : VesselPickerField (MODIFIED: was Select dropdown)
 *   - Registered Name   : text (disabled — auto-populated from vessel code)
 *   - Effectivity Date  : date picker
 *   - Vessel Name       : text (disabled — auto-populated from vessel code)
 */
export const VesselDetailsTab = ({ mode, form, set, options, isViewOnly, errors = {} }) => { // MODIFIED: added errors prop with default value
  const editable = !isViewOnly;

  // MODIFIED: handler for VesselPickerField
  const handleVesselSelect = (vessel) => {
    set("vesselId", vessel.id);
    set("vesselCode", vessel.code);
    set("registeredName", vessel.registeredName || "");
    set("vesselName", vessel.name || "");
  };

  // ADDED: handler for clearing vessel
  const handleVesselClear = () => {
    set("vesselId", "");
    set("vesselCode", "");
    set("registeredName", "");
    set("vesselName", "");
  };

  return (
    <div className="space-y-6 pt-2">
      <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
        <SectionBadge label="Vessel Details" editable={editable} />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-4">
          {/* REPLACED: Select with VesselPickerField */}
          <VesselPickerField
            label="Vessel Code"
            isRequired={true}
            vesselId={form.vesselId || ""}
            displayValue={form.vesselCode || ""}
            onSelect={handleVesselSelect}
            onClear={handleVesselClear}
            allowClear={false}
            disabled={!editable || mode === "edit"} // ADDED: disable in edit mode
            error={!!errors.vesselId} // ADDED: error prop
            errorMessage={errors.vesselId} // ADDED: errorMessage prop
          />
          <Input
            label="Registered Name:"
            value={form.registeredName || ""}
            disabled={true}
            placeholder="-- Auto-populated --"
          />
          <DateInput
            label="Effectivity Date:"
            value={form.effectiveDate || ""}
            onChange={(e) => set("effectiveDate", e.target.value)}
            disabled={!editable}
            isRequired={true}
            error={errors.effectiveDate && !form.date}
            errorMessage={errors.effectiveDate} // ADDED: errorMessage prop
          />
          <Input
            label="Vessel Name:"
            value={form.vesselName || ""}
            disabled={true}
            placeholder="-- Auto-populated --"
          />
        </div>
      </div>
    </div>
  );
};

const SectionBadge = ({ label, editable }) => (
  <div className="flex items-center justify-between mb-4">
    <span className="text-xs font-bold uppercase tracking-widest text-gray-400">
      {label}
    </span>
    <span
      className={`text-[10px] px-2 py-0.5 rounded-full font-semibold border ${
        editable
          ? "bg-green-50 text-green-700 border-green-200"
          : "bg-gray-100 text-gray-400 border-gray-200"
      }`}
    >
      {editable ? "Editable" : "View Only"}
    </span>
  </div>
);